export interface OrganizationDetails {
	id: number;
	name: string;
	address: OrganizationAddress;
	role: string;
	status: string;
	vatNumber: string;
	administrator: OrganizationAdministrator;
	personMembers: OrganizationPersonMember[];
	diffusions: OrganizationDiffusion[];
	visibilityGroups: OrganizationVisibilityGroup[];
	suppliers: OrganizationSupplier[];
}

interface OrganizationAddress {
	city: string;
	countryCode: string;
	countryCodeDescription?: string;
	county: string;
	zipCode: string;
	address: string;
}

interface OrganizationAdministrator {
	id: number;
	firstName: string;
	lastName: string;
}

interface OrganizationPersonMember {
	firstName: string;
	lastName: string;
}

interface OrganizationDiffusion {
	serviceCode: string;
	label: string;
}

interface OrganizationVisibilityGroup {
	organizationVisibility: OrganizationVisibility[];
}

interface OrganizationVisibility {
	name: string;
	isSoldTo: number;
	isShipTo: number;
	isPayer: number;
}

interface OrganizationSupplier {
	id: number;
	name: string;
}

export const organizationDetailsFields = <const> [
	'id',
	'name',
	'role',
	'status',
	'address.addressLine1',
	'address.city',
	'address.countryCode',
	'address.county',
	'address.zipCode',
	'vatNumber',
	'superUser.id',
	'superUser.firstName',
	'superUser.lastName',
	'supplierGroupMembers.supplierGroup.id',
	'supplierGroupMembers.supplierGroup.name'
];
